/* Updates the low-stock indicator when the selected variant changes.
   Reuses the theme's variantChange pub/sub event (see global.js renderProductInfo). */
if (!customElements.get('stock-indicator')) {
  customElements.define(
    'stock-indicator',
    class StockIndicator extends HTMLElement {
      connectedCallback() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (!event || !event.data || !event.data.html) return;
          const source = event.data.html.getElementById(this.id);
          this.innerHTML = source ? source.innerHTML : '';
        });
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }
    }
  );
}
